<template>
<b-form-group 
    :id="'fieldset-horizontal-label-' + parentFormID + '-' + index + '-' + dataName"
    label-cols-sm="4"
    label-cols-lg="3"
    description=""
    :label="inputLabel"
    :label-size="size"
    :label-for="'input-horizontal-input-' + parentFormID + '-' + index + '-' + dataName"
    :invalid-feedback="invalidFeedback"
    :state="validationResult.all"
>
    <b-input-group>
        <template v-if="(prependComponent != null)" v-slot:prepend>
            <component 
                :is="prependComponent"
                :touch="prependInput"
                :size="size"
            ></component>
        </template>
        <b-form-input 
            :id="'input-horizontal-input-' + parentFormID + '-' + index + '-' + dataName"
            type="text"
            v-model="inputValue"
            @input="touch($event)"
            :formatter="inputFormat"
            :required="required"
            :state="validationResult.all"
            :readonly="readOnly"
            :size="size"
            @keyup.enter.native="appendInput"
        ></b-form-input>
        <template v-if="(appendComponent != null)" v-slot:append>
            <component 
                :is="appendComponent"
                :touch="appendInput"
                :size="size"
            ></component>
        </template>
    </b-input-group>
    
</b-form-group > 
    
</template>

<script>
const cloneDeep = require('lodash.clonedeep');
import phoneNumberLib from '../libs/phone_numbers.js'
import MicroArrayAddButton from '@/components/microcomponents/ArrayItemAddButton.vue'
import MicroArrayRemoveButton from '@/components/microcomponents/ArrayItemRemoveButton.vue'

//import { ValidationBus } from '@/validationBus.js';


export default {
    name: 'formphoneinput',
    components:{
        'btn-add': MicroArrayAddButton,
        'btn-remove': MicroArrayRemoveButton
    },
    props:{
        //bus: Object,
        dataName: String,
        inputLabel: String,
        parentFormID: String,
        value: {
            type: String,
            default: () => {return ""}
        },
        required: {
            type: Boolean,
            default: () => {return false} 
        },
        readOnly: {
            type: Boolean,
            default: () => {return false} 
        },
        index: {
            type: Number,
            default: () => {return -1;}
        },
        appendComponent: {
            type: String,
            default: () => {return null} 
        },
        prependComponent: {
            type: String,
            default: () => {return null} 
        },
        size: {
            type: String,
            validator: (val) =>{
                // The value must match one of these strings
                return ['sm', 'md', 'lg'].indexOf(val) != -1
            },
            default: () => {return "md"}
        }
    },
    data(){
        return{
            inputValue: '',
            originalValue: '',
            isDirty: false,
        }
    },
    methods: {
        touch() {
            this.isDirty = true;
            this.$store.commit('updateFormValue', {parentFormID: this.parentFormID, type: this.$options.name, dataName: this.dataName, index: this.index, value: this.cleanedInput, valid: this.validationResult.all, isDirty: this.isDirty} );
        },
        appendInput(){
            if(this.appendComponent == 'btn-add'){
                // we are adding an item
                this.$store.commit('formAppend', {parentFormID: this.parentFormID, dataName: this.dataName, index: this.index, valid: this.validationResult.all});
                this.inputValue = "";
                this.isDirty = false;
                this.$store.commit('updateFormValue', {parentFormID: this.parentFormID, type: this.$options.name, dataName: this.dataName, index: this.index, value: this.cleanedInput, valid: this.validationResult.all, isDirty: this.isDirty} );
            }else if(this.appendComponent == 'btn-remove'){
                // We are removing an item
                this.$store.commit('removeFormValue', {parentFormID: this.parentFormID, dataName: this.dataName, index: this.index} );
                this.$store.commit('formAppend', {parentFormID: this.parentFormID, dataName: this.dataName, index: this.index, valid: this.validationResult.all});
            }else{
                this.$store.commit('updateFormValue', {parentFormID: this.parentFormID, type: this.$options.name, dataName: this.dataName, index: this.index, value: this.cleanedInput, valid: this.validationResult.all, isDirty: this.isDirty} );
            }
        },
        prependInput(){
            this.$store.commit('formPrepend', {parentFormID: this.parentFormID, dataName: this.dataName, index: this.index, valid: this.validationResult.all});
        },
        inputFormat(input){
            return phoneNumberLib.format(input);
        },
        cleanInput(input){
            return phoneNumberLib.clean(input);
        }
    },
    watch: { 
        index: function(newVal, oldVal) { // watch it
            console.log('Index Changed: ', newVal, ' | was: ', oldVal)
        }
    },
    computed: {
        // a computed getter
        validationResult: function () {
            // var regexRes = ( (!this.required) ? this.validator.test(this.inputValue) || this.inputValue.length == 0 : this.validator.test(this.inputValue) );
            var requiredRes = ( (this.required) ? false : true) ;
            var lengthOk = true;
            var reqLength = 10;

            if(this.cleanedInput[0] == '1')
                reqLength = 11;

            if(this.cleanedInput.length < reqLength && this.required){
                lengthOk = false
            }else if(this.cleanedInput.length < reqLength && this.cleanedInput.length != 0){
                lengthOk = false
            }

            return {isPhoneNumber: lengthOk, requirementFilled: requiredRes, all: (lengthOk && requiredRes)};
        },
        invalidFeedback(){
            var res = this.validationResult;
            if(res.all)
                return ''
            else if(!res.requirementFilled)
                return 'Required'
            else if(!res.isPhoneNumber)
                return 'Invalid Entry: Expects Phone Number'
            else
                return 'OK'
        },
        cleanedInput(){
            return this.inputValue.replace(/\D/g,'');
        }
    },
    mounted(){
        this.$store.commit('registerFormValue', {parentFormID: this.parentFormID, type: this.$options.name, dataName: this.dataName, index: this.index, value: this.cleanedInput, valid: this.validationResult.all} );
    },
    created(){
    },
    beforeDestroy(){
        if(this.index == -1){
            this.$store.commit('removeFormValue', {parentFormID: this.parentFormID, dataName: this.dataName, index: this.index} );
        }
    },
    beforeMount (){
        this.originalValue = cloneDeep(this.value);
        this.inputValue = this.inputFormat(this.value);
    },
}
</script>

<style>

</style>


